import { Seo } from '../components/seo.js';
import { HeroSection } from '../features/storefront/home/components/hero-section.js';
import { TrendingDealsSection } from '../features/storefront/home/components/trending-deals-section.js';
import { FeaturedCategoriesSection } from '../features/storefront/home/components/featured-categories-section.js';
import { ProductSection } from '../features/storefront/home/components/product-section.js';
import { RewardsPromoSection } from '../features/storefront/home/components/rewards-promo-section.js';
import { TrustBadgesSection } from '../features/storefront/home/components/trust-badges-section.js';

/**
 * The storefront homepage -- every data-backed section (hero, categories,
 * product rails) fetches its own real data independently and fails
 * gracefully on its own, so one section's API error never blanks the rest
 * of the page. Static promotional/trust content (delivery promise, trust
 * badges, rewards link) is clearly non-catalog copy, never a fabricated
 * product.
 */
export function HomePage() {
  return (
    <>
      <Seo
        title="TSG eCart — Fresh groceries delivered fast"
        description="Fruits, vegetables, staples and daily essentials delivered to your door in under 60 minutes."
        canonicalPath="/"
        ogType="website"
      />
      <HeroSection />
      <TrendingDealsSection />
      <FeaturedCategoriesSection />
      <ProductSection
        title="Best sellers"
        params={{ sortField: 'popularity', sortDirection: 'desc', limit: 8, offset: 0 }}
        tone="muted"
      />
      <ProductSection
        title="New arrivals"
        params={{ sortField: 'createdAt', sortDirection: 'desc', limit: 8, offset: 0 }}
      />
      <RewardsPromoSection />
      <TrustBadgesSection />
    </>
  );
}
